import { LoadingSpinner } from "@/components/LoadingSpinner";

export type PaymentLoadingStage =
  | "applying shipping"
  | "verifying totals"
  | "fixing order";

interface PaymentLoadingStatusProps {
  stage: PaymentLoadingStage;
}

export function PaymentLoadingStatus({ stage }: PaymentLoadingStatusProps) {
  return (
    <div
      className="mb-4 flex items-center justify-center gap-2 text-sm text-(--color-text-secondary)"
      role="status"
      aria-live="polite"
    >
      <LoadingSpinner size="sm" />
      <span>{stage}</span>
    </div>
  );
}
